export default __webpack_public_path__ + "static/media/logo-california-blueshield.c6c9009b.png";